var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-field-busca',{ref:"fieldBusca",attrs:{"model":_vm.model,"field":"cidade","width":"1000","component":"app-cidade-grid","label":"Cidade"},on:{"change":function (v) { return _vm.$emit('change', v); }}})}
var staticRenderFns = []

export { render, staticRenderFns }